import { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { api } from "services/api";
import { Header } from "components/Header";
import { useNavigate } from "react-router-dom";
import ButtonComp from "components/Button";
import PaginationComp from "components/PaginationComp";

const headers = ["Proﬁles"];

// const items = [
//   {
//     id: 1,
//     Profiles: "Proﬁles Admin",
//   },
// ];

const PermissionProfiles = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);
  const navigate = useNavigate();

  // const onOpen = () => {
  //   navigate("/permissionmanage", {
  //     state: { action: "permission-edit", data: selectedItem?.item?.data },
  //   });
  // };

  const onSelectItm = (data) => {
    // setSelectedItem(data);
    navigate("/permissionmanage", {
      state: { action: "permission-edit", data: data?.item?.data },
    });
  };

  const onNew = () => {
    navigate("/permissionmanage", {
      state: { action: "permission-add" },
    });
  };

  const getList = (data) => {
    setIsLoading(true);
    api
      .getPermission({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getPermission", res?.data);
        if (res?.status === 200) {
          if (data?.page) {
            setActivePage(data.page);
          }
          if (res?.data && res?.data[0]?.permissionid) {
            setList(
              res.data.map((item) => ({
                id: item.permissionid,
                permissionname: item.permissionname,
                data: item,
              }))
            );
          } else {
            setList([]);
          }

          // if (res?.data?.settingtype === "VAT") {
          // setSettingvalue(res?.data?.settingvalue);
          // }
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      // searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Permission Profiles"} isLoading={isLoading} />
      <Flex
        direction={"row"}
        w={"100%"}
        justifyContent="space-between"
        gap={"1rem"}
        mb={"1rem"}
      >
        {/* <DropDown/> */}

        {/* <Button variant="outline" onClick={onOpen} disabled={!selectedItem}>
          Open
        </Button> */}
        <Flex
          // gap={"3"}
          direction={"row"}
          alignSelf={"end"}
          w={"100%"}
          justify={"flex-end"}
        >
          {/* <InputComp placeholder="Profile Name" /> */}
          <ButtonComp label="New" onClick={onNew} keyname="new" />
        </Flex>
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
};

export default PermissionProfiles;
